import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { showLoader, showMessage, userSignOutSuccess, handleHTTPError } from 'store/actions';
import { searchClubEvents } from 'apis';
import moment from 'moment-timezone';
import PageContentLayout from 'components/PageContentLayout';
import { Constants } from 'utils/constants';
import { Button, Col, Row } from 'reactstrap';
import DatePicker from 'components/controls/DatePicker';
import { downloadCSV } from 'utils';

class EventsReportList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stDate: moment().startOf('month').toDate(),
            etDate: moment().endOf('month').toDate(),
            reports: [],
        };
    }

    componentDidMount = () => {
        this.searchEvents();
    };

    searchEvents = async () => {
        try {
            this.props.showLoader(true);
            const params = {
                stDate: moment(this.state.stDate).format('YYYY-MM-DD'),
                etDate: moment(this.state.etDate).format('YYYY-MM-DD'),
                'isFree.ne': true,
            };
            const { data: events } = await searchClubEvents(params);
            const reportClubs = events
                .map((x) => x.club)
                .filter((x, index, self) => self.findIndex((v) => v._id === x._id) === index);
            const reports = reportClubs.map((x) => {
                const cEvents = events.filter((v) => v.club._id === x._id);
                let attendees = [];
                let onlinePay = 0;
                let clubPay = 0;
                for (const evt of cEvents) {
                    if (evt.isClubCharge) {
                        const regUsers = evt.regUsers.filter(
                            (x) => x.status === Constants.CLUBEVENT_REGUSER_STATUS.REGISTERED && !x.isWaitList
                        );
                        attendees = [...attendees, ...regUsers];
                        clubPay += evt.price * regUsers.length;
                    } else {
                        const regUsers = evt.regUsers.filter(
                            (x) =>
                                x.status === Constants.CLUBEVENT_REGUSER_STATUS.REGISTERED &&
                                !x.isWaitList &&
                                x.paymentIntentId
                        );
                        attendees = [...attendees, ...regUsers];
                        onlinePay += regUsers.reduce((acc, x) => (acc += x.paidAmount), 0);
                    }
                }
                return {
                    club: x,
                    events: cEvents,
                    attendees,
                    onlinePay,
                    clubPay,
                };
            });
            this.setState({ reports });
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.props.showLoader(false);
        }
    };

    downloadReport = (report) => {
        let csvDatas = [];
        report.events.forEach((event, index) => {
            event.regUsers.forEach((regUser, rIndex) => {
                if (rIndex === 0)
                    csvDatas.push({
                        No: index + 1,
                        'Date Time': event.start,
                        'Event Title': event.title,
                        Attendees: regUser.user?.fullName,
                        'Payment Type': event.isClubCharge ? 'Club Charge' : 'Online Pay',
                        Amount: event.isClubCharge ? event.price : regUser.paidAmount,
                    });
                else
                    csvDatas.push({
                        No: '',
                        'Date Time': '',
                        'Event Title': '',
                        Attendees: regUser.user?.fullName,
                        'Payment Type': event.isClubCharge ? 'Club Charge' : 'Online Pay',
                        Amount: event.isClubCharge ? event.price : regUser.paidAmount,
                    });
            });
        });
        downloadCSV(
            csvDatas,
            `${report.club.displayName}_Event Report (${moment(this.state.stDate).format('YYYY-MM-DD')}~${moment(
                this.state.etDate
            ).format('MM-DD')})`
        );
    };

    render() {
        const generateBody = () => {
            return this.state.reports.map((x, index) => {
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{x.club.displayName}</td>
                        <td>{x.events.length}</td>
                        <td>{x.attendees.length}</td>
                        <td>$ {x.onlinePay}</td>
                        <td>$ {x.clubPay}</td>
                        <td>$ {x.onlinePay + x.clubPay}</td>
                        <td className="d-flex justify-content-center ">
                            <div
                                className="text-gray pointer text-primary mr-3"
                                onClick={() => {
                                    this.props.history.push(
                                        `${this.props.match.url}/${x.club._id}?from=${moment(this.state.stDate).format(
                                            'YYYY-MM-DD'
                                        )}&to=${moment(this.state.etDate).format('YYYY-MM-DD')}`
                                    );
                                }}
                            >
                                <FontAwesomeIcon icon="search" />
                                &nbsp;&nbsp;View
                            </div>
                            <div className="text-gray pointer text-primary" onClick={() => this.downloadReport(x)}>
                                <FontAwesomeIcon icon="download" />
                                &nbsp;&nbsp;Download
                            </div>
                        </td>
                    </tr>
                );
            });
        };

        return (
            <PageContentLayout title="Event Billing Report">
                <Row className="mb-3">
                    <DatePicker
                        className="col-md-3 "
                        label="From"
                        selected={this.state.stDate}
                        startDate={this.state.stDate}
                        endDate={this.state.etDate}
                        maxDate={this.state.etDate}
                        onChange={(date) => {
                            this.setState({ stDate: date });
                        }}
                        dateFormat="MMMM dd, yyyy"
                    />
                    <DatePicker
                        className="col-md-3 "
                        label="To"
                        selected={this.state.etDate}
                        startDate={this.state.stDate}
                        endDate={this.state.etDate}
                        minDate={this.state.stDate}
                        onChange={(date) => {
                            this.setState({ etDate: date });
                        }}
                        dateFormat="MMMM dd, yyyy"
                    />
                    <Col md={3} />
                    <Col md={3} className="d-flex align-items-end">
                        <Button color="primary" block size="lg" className="mb-0" onClick={this.searchEvents}>
                            Search
                        </Button>
                    </Col>
                </Row>
                <table className="table table-bordered">
                    <thead className="bg-primary text-white">
                        <tr>
                            <th>No</th>
                            <th>Club Name</th>
                            <th>Events</th>
                            <th>Attendees</th>
                            <th>Online Pay</th>
                            <th>Club Pay</th>
                            <th>Total</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.reports.length === 0 && (
                            <tr>
                                <td colSpan="8" className="text-danger text-center">
                                    No Data
                                </td>
                            </tr>
                        )}
                        {generateBody()}
                    </tbody>
                </table>
            </PageContentLayout>
        );
    }
}

const mapStateToProps = ({ user, ui }) => {
    const { isLoader } = ui;
    const { authUser } = user;
    return { isLoader, authUser };
};

export default withRouter(
    connect(mapStateToProps, {
        showLoader,
        showMessage,
        userSignOutSuccess,
        handleHTTPError,
    })(EventsReportList)
);
